/**
 * Who counts as the MSP's own staff, as the server decides it
 * (backend config/roles.js). Finance included, everywhere.
 */
const INTERNAL_ROLES = Object.freeze(['finance', 'technician', 'admin']);

export const isInternalRole = (role) => INTERNAL_ROLES.includes(role);
